import styled from "styled-components";

import { DonutChart } from "./DonutChart";
import { MissingDataPlaceholder } from "./MissingDataPlaceholder";

import { palette, pxToRem } from "@otta/design-tokens";
import { Text } from "@otta/design";

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  gap: ${pxToRem(24)};
  padding: ${pxToRem(16)};
  border: 1px solid ${palette.grayscale.shade200};
  border-radius: ${pxToRem(8)};
`;

const ChartWrapper = styled.div`
  align-self: center;
`;

const Legend = styled.ul`
  display: flex;
  flex-wrap: wrap;
  gap: ${pxToRem(8)};
`;

const LegendItem = styled.li<{ color: string }>`
  display: flex;
  align-items: center;
  gap: ${pxToRem(3)};

  &::before {
    content: "";
    width: ${pxToRem(12)};
    height: ${pxToRem(12)};
    border-radius: 50%;
    background-color: ${props => props.color};
  }
`;

const NoDataPlaceholder = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${pxToRem(16)};
`;

type Item = {
  color: string;
  value: number;
  percent: string;
  name: string;
};

export const MessageOutcome = ({ data = [] }: { data: Item[] }) => {
  const hasData = data.reduce((acc, item) => acc + item.value, 0) > 0;

  if (!hasData) {
    return (
      <NoDataPlaceholder>
        <Text bold>Message outcome</Text>
        <MissingDataPlaceholder size="small" />
      </NoDataPlaceholder>
    );
  }

  return (
    <Wrapper>
      <Text bold>Message outcome</Text>
      <ChartWrapper>
        <DonutChart data={data} />
      </ChartWrapper>
      <Legend>
        {data.map(item => (
          <LegendItem key={item.name} color={item.color}>
            <Text size={-1}>
              {item.name}: {item.value} ({item.percent}%)
            </Text>
          </LegendItem>
        ))}
      </Legend>
    </Wrapper>
  );
};
